import { introAssets } from '../constants/assets';
import { publicPanels } from '../data/siteContent';

function HomePage() {
  return (
    <section className="home-section" aria-labelledby="home-title">
      <div className="home-lead">
        <span className="section-kicker">Marlta Official</span>
        <h1 id="home-title">승마 예약을 더 쉽게, 말타</h1>
        <p>
          승마장 탐색부터 프로그램 확인, 기승 예약과 강습 내역 관리까지 말타에서
          자연스럽게 이어집니다.
        </p>
        <div className="home-actions">
          <a className="primary-action" href="#/intro">
            앱 소개 보기
          </a>
          <a className="secondary-action" href="#/services">
            서비스 보기
          </a>
        </div>
      </div>

      <div className="home-visual-stack">
        <div className="home-showcase" aria-hidden="true">
          <img src={introAssets.hero} alt="" />
          <span>예약부터 기록까지 한 번에</span>
        </div>

        <div className="quick-panels">
          {publicPanels.map((panel) => (
            <article className="surface-card" key={panel.title}>
              <h2>{panel.title}</h2>
              <p>{panel.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomePage;
